if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-upsell-track]');
        this.prev = this.querySelector('[data-upsell-prev]');
        this.next = this.querySelector('[data-upsell-next]');

        this.prev?.addEventListener('click', () => this.scroll(-1));
        this.next?.addEventListener('click', () => this.scroll(1));
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        this.updateArrows();

        this.addEventListener('change', (event) => {
          const select = event.target.closest('[data-upsell-variant]');
          if (!select) return;
          event.stopPropagation();
          const option = select.selectedOptions[0];
          const card = select.closest('.cart-upsell__card');
          card.querySelector('[data-upsell-add]').dataset.variantId = select.value;
          card.querySelector('[data-upsell-price]').textContent = option.dataset.price;
        });

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-upsell-add]');
          if (button) this.add(button);
        });
      }

      scroll(direction) {
        const item = this.track.querySelector('.cart-upsell__item');
        const step = item ? item.getBoundingClientRect().width + 12 : this.track.clientWidth;
        this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.prev || !this.next) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max;
      }

      async add(button) {
        if (button.getAttribute('aria-disabled') === 'true') return;
        const card = button.closest('.cart-upsell__card');
        const error = card.querySelector('.cart-upsell__error');
        const spinner = button.querySelector('.loading__spinner');
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        spinner?.classList.remove('hidden');
        error.hidden = true;

        try {
          const body = JSON.stringify({
            items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          });
          const response = await fetch(routes.cart_add_url, { ...fetchConfig(), body }).then((res) => res.json());

          if (response.status) {
            error.textContent = response.description || response.message || window.cartStrings?.error || '';
            error.hidden = false;
            return;
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer && response.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ ...response, id: response.items?.[0]?.id });
          }
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: response });
        } catch (e) {
          console.error(e);
        } finally {
          if (button.isConnected) {
            button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
            spinner?.classList.add('hidden');
          }
        }
      }
    }
  );
}
